import { webhookApi } from "./webhookApi";

export const getWebhooksOptions = async (params: { offset: number; limit: number; query?: string }) => {
  const webhooksResponse = await webhookApi.getWebhooks({
    offset: params.offset || 0,
    limit: params.limit || 20,
    filter: {
      query: params.query || "",
    },
  });
  const webhooksOptions = webhooksResponse.data.data.map((webhook) => {
    const option = {
      value: webhook.uuid,
      label: webhook.name,
    };
    return option;
  });
  return {
    options: webhooksOptions,
    hasMore: webhooksResponse.data.has_more,
  };
};

export const getWebhooksExportedOptions = async (params: { offset: number; limit: number; query?: string }) => {
  const webhooksResponse = await webhookApi.getWebhooks({
    offset: params.offset || 0,
    limit: params.limit || 20,
    filter: {
      query: params.query || "",
      event: "contact_exported",
      status: "on",
    },
  });
  const leadsOptions = webhooksResponse.data.data.map((webhook) => {
    const option = {
      value: webhook.uuid,
      label: webhook.name,
    };
    return option;
  });
  return {
    options: leadsOptions,
    hasMore: webhooksResponse.data.has_more,
  };
};
export const getWebhooksExportedOptionsOldFormat = async (query?: string) => {
  const webhooksResponse = await webhookApi.getWebhooks({
    offset: 0,
    limit: 20,
    filter: {
      query: query || "",
      event: "contact_exported",
      status: "on",
    },
  });
  const leadsOptions = webhooksResponse.data.data.map((webhook) => {
    const option = {
      value: webhook.uuid,
      label: webhook.name,
    };
    return option;
  });
  return leadsOptions;
};

